import { Swiper } from 'swiper'
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules'

window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('shop_single')) return

  let thumbSwiper = new Swiper('.shop_thumbs', {
    slidesPerView: 5,
    spaceBetween: 10,
    watchSlidesProgress: true,
  })

  let mainSwiper = new Swiper('.shop_slider', {
    modules: [Navigation, Pagination, Thumbs],
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.shop_next',
      prevEl: '.shop_prev',
    },
    pagination: {
      el: '.shop_pagination',
      clickable: true,
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  })

  let waySwiper = new Swiper('.way_slider', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
})
